import * as firebase from 'firebase'
import { FIREBASE } from './config'

firebase.initializeApp(FIREBASE)
const rankRef = firebase.database().ref('ranks/')
const servantRanksRef = firebase.database().ref('servantRanks/')
const servantsRef = firebase.database().ref('servants/')
const storageRef = firebase.storage().ref('servants/')

firebase.auth().signInAnonymously().catch(function(error) {
  console.log(error.code, error.message)
})

export {
  rankRef,
  servantRanksRef,
  servantsRef,
  storageRef,
}



// WEBPACK FOOTER //
// ./src/lib/firebaseService.js